module.exports = __webpack_public_path__ + "src/assets/img/santander.858e4a69.svg";